/*
 * Jira Ticket:
 * Created Date: Wed, 11th Mar 2020, 11:57:00 am
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import React, { cloneElement, useState, useEffect } from 'react';
import {
  TopToolbar,
  CreateButton,
  sanitizeListRestProps,
  useDataProvider,
} from 'react-admin';
import { Help } from '@material-ui/icons';
import { ActionButton } from 'Components/Buttons';
import { useDispatch } from 'react-redux';
import getHelp from '../../utils/getHelp';

const OrganisationActions = ({
  currentSort,
  className,
  resource,
  filters,
  displayedFilters,
  exporter, // you can hide ExportButton if exporter = (null || false)
  filterValues,
  permanentFilter,
  hasCreate, // you can hide CreateButton if hasCreate = false
  basePath,
  selectedIds,
  onUnselectItems,
  showFilter,
  maxResults,
  total,
  ...rest
}) => {
  const dataProvider = useDataProvider();
  const dispatch = useDispatch();
  const [helpLink, setHelpLink] = useState();

  const useMountEffect = fun => useEffect(fun, []);
  useMountEffect(
    getHelp('help_url_organisation', { dataProvider, dispatch, setHelpLink })
  ); // run once

  return (
    <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
      {helpLink && (
        <ActionButton
          label="resources.General.help"
          variant="text"
          onClick={() => {
            window.open(helpLink);
          }}
          icon={<Help />}
        />
      )}
      {filters &&
        cloneElement(filters, {
          resource,
          showFilter,
          displayedFilters,
          filterValues,
          context: 'button',
        })}
      <CreateButton basePath={basePath} />
    </TopToolbar>
  );
};

OrganisationActions.defaultProps = {
  selectedIds: [],
  onUnselectItems: () => null,
};

export default OrganisationActions;
